(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mool-slideshow"] && !Shopify.designMode) return;
  try {
    
(function () {
  const slideshows = document.querySelectorAll('[data-mool-slideshow]');
  slideshows.forEach(function (slideshow) {
    const slides = slideshow.querySelectorAll('.mool-slideshow__slide');
    const dots = slideshow.querySelectorAll('.mool-slideshow__dot');
    if (slides.length <= 1) return;
    let current = 0;
    let timer = null;

    function show(index) {
      slides.forEach(function (s, i) {
        s.classList.toggle('is-active', i === index);
      });
      dots.forEach(function (d, i) {
        d.classList.toggle('is-active', i === index);
      });
      current = index;
    }

    function next() {
      show((current + 1) % slides.length);
    }

    function start() {
      stop();
      timer = setInterval(next, 5000);
    }

    function stop() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        show(i);
        start();
      });
    });

    slideshow.addEventListener('mouseenter', stop);
    slideshow.addEventListener('mouseleave', start);

    start();
  });
})();

  } catch(e) { console.error(e); }
})();
})();
